import { NotificationsContainer } from '../containers/Notifications/NotificationsContainer'


export const NotificationsMessages = (props) => (
    <NotificationsContainer getCountNotice={props.getCountNotice}/>
)